import './App.scss';
import React from 'react';
import { AppRouter } from './AppRouter';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

export default class App extends React.Component<object> {
  render() {
    return (
      <div className="App flex-column">
        <QueryClientProvider client={queryClient}>
          <AppRouter />
        </QueryClientProvider>
      </div>
    );
  }
}
